import React, { Suspense, useLayoutEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { RedirectAs404 } from "../utils";

import Faq from "../pages/others/Faq";
import Terms from "../pages/others/Terms";
import Dashboard from "../pages/tabs/dashboard/Dashboard";

import UserRoleList from "../pages/tabs/others/user-role/UserRoleList";

import AddUserRole from "../pages/tabs/others/user-role/AddUserRole";

import VerifyPassword from "../pages/auth/CheckPassword";
import CreatePassword from "../pages/auth/CreatePassword";
import Resident from "../pages/tabs/Resident/Resident";
import Transaction from "../pages/tabs/Transaction/Transaction";
import Reco from "../pages/tabs/Reco/Reco";

import AddTransaction from "../pages/tabs/Transaction/AddTransaction";

import StaffList from "../pages/tabs/others/Staff/StaffList";
import LocationList from "../pages/tabs/others/Location/LocationList";
import CustomTransaction from "../pages/tabs/account/AccountTransaction";
import AuditTrail from "../pages/tabs/AuditTrail/AuditTrail";

const Pages = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Suspense fallback={<div />}>
      <Routes>
        {/*Dashboards*/}
        <Route path={`${process.env.PUBLIC_URL}/`} element={<Dashboard />}></Route>

        <Route path={`${process.env.PUBLIC_URL}/location`} element={<LocationList />}></Route>

        <Route path={`${process.env.PUBLIC_URL}/staff`} element={<StaffList />}></Route>

        <Route path={`${process.env.PUBLIC_URL}/roles`} element={<UserRoleList />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/add-userrole`} element={<AddUserRole />}></Route>

        <Route path={`${process.env.PUBLIC_URL}/check-password`} element={<VerifyPassword />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/change-password`} element={<CreatePassword />}></Route>

        {/*Demo Pages*/}
        <Route path={`${process.env.PUBLIC_URL}/pages/terms-policy`} element={<Terms />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/pages/faq`} element={<Faq />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/resident`} element={<Resident />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/transaction`} element={<Transaction />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/transaction/:id`} element={<Transaction />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/add-transaction`} element={<AddTransaction />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/account`} element={<CustomTransaction />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/reco`} element={<Reco />}></Route>
        <Route path={`${process.env.PUBLIC_URL}/audit-trail`} element={<AuditTrail />}></Route>
        <Route path="*" element={<RedirectAs404 />}></Route>
      </Routes>
    </Suspense>
  );
};
export default Pages;
